import { render, staticRenderFns } from "./EnhancedAdminDashboard.vue?vue&type=template&id=b2ec67f6&scoped=true"
import script from "./EnhancedAdminDashboard.vue?vue&type=script&lang=js"
export * from "./EnhancedAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./EnhancedAdminDashboard.vue?vue&type=style&index=0&id=b2ec67f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ec67f6",
  null
  
)

export default component.exports